import { useSyncExternalStore } from 'react';

import type { MotionEditorPanel } from './components/panels/types';

export const ENABLE_CHARACTER_PICKER_PANEL = true;
export const ENABLE_HISTORY_PANEL = true;
export const ENABLE_FRONT_DOOR = true;
export const ENABLE_MOTION_EDITOR_ADVANCED_GHOST_OPTIONS = false;
export const ENABLE_MOTION_EDITOR_KEY_POSE_SURFACES = true;
export const ENABLE_MOTION_EDITOR_REPATHING = true;

export const DEBUG_STAMP_EVERY_STORAGE_KEY = 'debugStampEvery';

export function isDebugStampEveryEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return (
      window.localStorage.getItem(DEBUG_STAMP_EVERY_STORAGE_KEY) === 'true'
    );
  } catch {
    return false;
  }
}

export function useDebugStampEveryEnabled(): boolean {
  return useSyncExternalStore(
    subscribeToDebugStampEveryStorage,
    isDebugStampEveryEnabled,
    () => false,
  );
}

function subscribeToDebugStampEveryStorage(callback: () => void) {
  window.addEventListener('storage', callback);
  return () => window.removeEventListener('storage', callback);
}

export function isMotionEditorPanelEnabled(
  panel: MotionEditorPanel | null,
): panel is MotionEditorPanel {
  switch (panel) {
    case 'character':
      return ENABLE_CHARACTER_PICKER_PANEL;
    case 'history':
      return ENABLE_HISTORY_PANEL;
    case 'stage':
      return true;
    case null:
      return false;
  }
}

export function canUseMotionEditorRepathing(isCartwheeler?: boolean): boolean {
  return ENABLE_MOTION_EDITOR_REPATHING && isCartwheeler === true;
}
